import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Campo password con toggle mostra/nascondi (occhio). Nascosta per default.
 * Inoltra tutte le props all'input (incluso data-testid); il bottone toggle
 * espone `${data-testid}-toggle`.
 */
export function PasswordField({ className = "", wrapperClassName = "", iconClassName = "", ...props }) {
  const [show, setShow] = useState(false);
  const tid = props["data-testid"];
  return (
    <div className={`relative ${wrapperClassName}`}>
      <input {...props} type={show ? "text" : "password"} className={`${className} pr-10`} />
      <button type="button" tabIndex={-1} aria-label={show ? "Nascondi password" : "Mostra password"}
        data-testid={tid ? `${tid}-toggle` : "password-toggle"}
        onClick={() => setShow((s) => !s)}
        className={`absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 ${iconClassName}`}>
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
